import { CircularProgressProps } from '@mui/material/CircularProgress'
import Center from '@common/Center'
import { FC } from 'react'
import { Box, keyframes } from '@mui/material'

const Loader: FC<CircularProgressProps> = ({ size = 56, ...otherProps }) => {
  const styleMap = keyframes`100% {transform: rotate(1turn)}`
  return (
    <Center
      contentOverrides={{
        display: 'flex',
        justifyContent: 'center',
        p: 4,
        mt: 4,
        mb: -4,
      }}
    >
      <Box
        sx={{
          width: '60px',
          aspectRatio: '1',
          display: 'grid',
          borderRadius: '50%',
          background: `
                linear-gradient(0deg, rgba(102, 102, 250, 0.5) 30%, #0000 0 70%, rgb(102, 102, 250) 0) 50% / 8% 100%,
                linear-gradient(90deg, rgba(102, 102, 250, 0.25) 30%, #0000 0 70%, rgba(102, 102, 250, 0.75) 0) 50% / 100% 8%
            `,
          backgroundRepeat: 'no-repeat',
          animation: `${styleMap} 1s infinite steps(12)`,
          '&::before, &::after': {
            content: '""',
            gridArea: '1 / 1',
            borderRadius: '50%',
            background: 'inherit',
            opacity: 0.915,
            transform: 'rotate(30deg)',
          },
          '&::after': {
            opacity: 0.83,
            transform: 'rotate(60deg)',
          },
          otherProps,
        }}
      />
    </Center>
  )
}

export default Loader
